/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a74c2b73d2087df71c05c3f4592f985>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */
import React from 'react';

import { ThirdPartyLogoWrapper } from '../wrapper';
import type { ThirdPartyLogoProps } from './types';

const markup =
	'<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#0acf83" d="M18.757 39.722c2.895 0 5.246-2.294 5.246-5.119v-5.119h-5.246c-2.896 0-5.247 2.294-5.247 5.12s2.35 5.118 5.247 5.118"/><path fill="#a259ff" d="M13.5 24.361c0-2.825 2.351-5.119 5.247-5.119h5.247v10.243h-5.247c-2.896 0-5.247-2.293-5.247-5.119z"/><path fill="#f24e1e" d="M13.5 14.119C13.5 11.294 15.85 9 18.747 9h5.247v10.243h-5.247c-2.896 0-5.247-2.293-5.247-5.119z"/><path fill="#ff7262" d="M23.951 9h5.247c2.896 0 5.247 2.294 5.247 5.119s-2.351 5.119-5.247 5.119h-5.247z"/><path fill="#1abcfe" d="M34.5 24.361c0 2.825-2.351 5.119-5.247 5.119s-5.302-2.294-5.302-5.119 2.351-5.119 5.247-5.119 5.247 2.294 5.247 5.119z"/></svg>';

/**
 * __FigmaIcon__
 *
 * A third-party logo icon for Figma.
 */
export function FigmaIcon({
	size,
	label = 'Figma',
	testId,
	type,
	UNSAFE_isUpdatedGeometry,
}: ThirdPartyLogoProps): React.JSX.Element {
	return (
		<ThirdPartyLogoWrapper
			markup={markup}
			label={label}
			size={size}
			testId={testId}
			type={type}
			UNSAFE_isUpdatedGeometry={UNSAFE_isUpdatedGeometry}
		/>
	);
}
